import Image from 'next/image';
import { sanitizeHTML } from "@/lib/utils";

interface LeftTitleRightParagraphData {
  heading?: {
    title?: string;
  };
  text?: {
    text?: string;
  };
}

export const fields = [
  "heading.title",
  "text.text",
] as const;

interface LeftTitleRightParagraphProps {
  data?: LeftTitleRightParagraphData;
}

export default function LeftTitleRightParagraph({ data }: LeftTitleRightParagraphProps) {
  if (!data) return null;
  
  return (
    <section className="w-full bg-white">
      <div className="max-w-screen-2xl mx-auto px-8 py-8 md:py-16">
        <div className="flex flex-col md:flex-row gap-8 md:gap-16">
          <div className="md:w-1/2">
            <h3 className="text-2xl md:text-4xl text-primary font-greycliff leading-tight">
              {data.heading?.title || ''}
            </h3>
          </div>
          <div className="md:w-1/2">
            {data.text?.text && (
              <div 
                className="text-[1rem] font-normal leading-normal md:text-xl text-primary font-greycliff md:leading-relaxed [&>*]:text-[1rem] [&>*]:font-normal [&>*]:leading-normal md:[&>*]:text-xl"
                dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
} 
